<template>
    <div class="academy-history-item">
        <div class="block mb-16">
            <div class="block-title">
                <div class="dot" />
                {{ $t('academy.landing.title[3]') }}
            </div>
            <Item
                :data="item"
                :label="false"
            />
        </div>
    </div>
</template>

<script>
import API from '@/api';
import { mapMutations } from 'vuex';
import Item from '@/components/Item.vue';

export default {
    components: {
        Item,
    },
    data() {
        return {
            item: {},
        };
    },
    computed: {
    },
    watch: {
        $route() {
            this.View();
        },
    },
    mounted() {
        this.View();
    },
    methods: {
        ...mapMutations('mNotification', ['setAlert', 'handleError']),
        async View() {
            try {
                const res = await API.EducationHistory.PublicFetchResource(this.$route.params.id, {
                    headers: {
                        'Content-Language': (this.$route.path.split('/')[1] || 'zhTw') === 'en' ? 'en' : 'zhTw',
                    },
                });
                this.item = res.data;
            } catch (e) {
                this.handleError({
                    message: e || this.$t('alertMessage.getdata-fail'),
                    color: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss">

</style>
